import { Policy } from "./Policy";
import { PolicyMeta } from "./PolicyMeta";

class Policies {
  /**
   *@param {Array<Policy>} policyCollection
   */
  constructor(policyCollection = []) {
    this.initialize(policyCollection);
  }

  /**
   * @param {School} school
   */
  setSchool(school) {
    this.$school = school;
  }

  /**
   * @returns {number}
   */
  numberOfPolicies() {
    return Object.keys(this.$policies).length;
  }

  /**
   * @returns {Array<Policy>}
   */
  toArray() {
    const data = [].concat(Object.values(this.$policies));
    return data;
  }

  /**
   * @returns {Array<Policy>}
   */
  policies() {
    return this.$policies;
  }

  /**
   * @param {string} name
   * @returns {Policy}
   */
  getPolicyByName(name) {
    return this.$policies[name];
  }

  /**
   * @param {string} name
   * @returns {boolean}
   */
  policyExists(name) {
    return !!this.$policies[name];
  }

  /**
   * Update a policy
   * @param {Policy} policy
   */
  setPolicy(policy) {
    // console.log('Setting policy', policy)
    this.$policies[policy.name()] = policy;
  }

  /**
   * @param {Array<Policy>} policyCollection
   * @returns {Policies}
   */
  initialize(policyCollection) {
    this.$policies = {};
    policyCollection.forEach((policy) => {
      this.$policies[policy.name()] = policy;
    });
    return this;
  }
}

/**
 * This is middleware to help the Angular 1 controllers be less terrible.
 */

/**
 * @param {Object} response
 * @returns {Policies}
 */
function createFromSinglePolicyAPIResponse(response) {
  const metaCollection = [];
  response.policy.policymeta.forEach((m) => {
    metaCollection.push(
      new PolicyMeta(m.id, m.policy_id, m.meta_key, m.meta_value),
    );
  });
  const policy = new Policy(response.policy.id, response.policy.name);

  policy.setMetaData(metaCollection);
  const policies = new Policies([policy]);
  return policies;
}

/**
 * @param {Object} response
 * @returns {Policies}
 */
function createFromPolicyAPIResponse(response) {
  const policyCollection = [];
  response.policies.forEach((policy) => {
    const metaCollection = [];
    policy.policymeta.forEach((meta) => {
      metaCollection.push(
        new PolicyMeta(meta.id, meta.policy_id, meta.meta_key, meta.meta_value),
      );
    });
    const $policy = new Policy(policy.id, policy.name);
    $policy.setMetaData(metaCollection);
    policyCollection.push($policy);
  });

  const policies = new Policies(policyCollection);
  return policies;
}

export {
  Policies,
  createFromSinglePolicyAPIResponse,
  createFromPolicyAPIResponse,
};
